import React from 'react';
import "./Doctors.css";
import doc from "./../../assets/doc.jpg";
import NavBar from '../NavBar/NavBar';

const Doctors = () => {
    return (
        <div className="cont">
        <div id="doctors" className="doctor-container" >
         <NavBar/>
                
                <a href = './#/profile' class='clickable'>
                    <div className="doc-profile">

                    <div className="top-icon">
                    <span class="material-icons">ios_share</span>
                    <span class="material-icons">favorite_border</span>
                    </div>

                    <div className="left-container-doc">
                        <img
                            src={doc}
                            alt=''
                            className='doc-img'
                        />
                        <p> 40 ratings <b> 4/5 </b> </p>
                    </div>

                    <div className="right-container-doc">
                        <h4 className='head'> Dr Amola Kumari, M.D</h4>
                        <p  className='head'>Orthopaedic surgeon | 12 Yrs Exp.</p>
                        <p  className='head'> <b>Practice Area:</b> Ankle sprain, Foot pain</p>
                        <div className="icon"><span class="material-icons"> location_on </span> <p className='head'> Old Palasia, Indore | Paras Hospital</p></div>
                        <p  className='head'> ₹500 Consultation fee at clinic</p>
                    </div>
                </div>  
            </a>

            <a href = './#/profile' class='clickable'>
                    <div className="doc-profile">

                    <div className="top-icon">
                    <span class="material-icons">ios_share</span>
                    <span class="material-icons">favorite_border</span>
                    </div>

                    <div className="left-container-doc">
                        <img
                            src={doc}
                            alt=''
                            className='doc-img'
                        />
                        <p> 60 ratings <b> 4.2/5 </b></p>
                    </div>

                    <div className="right-container-doc">
                        <h4 className='head'> Dr Amola Kumari, M.D</h4>
                        <p  className='head'>Orthopaedic surgeon | 12 Yrs Exp.</p>
                        <p  className='head'> <b>Practice Area:</b> Ankle sprain, Foot pain</p>
                        <div className="icon"><span class="material-icons"> location_on </span> <p className='head'> Old Palasia, Indore | Paras Hospital</p></div>
                        <p  className='head'> ₹500 Consultation fee at clinic</p>
                    </div>
                </div>  
            </a>

            <a href = './#/profile' class='clickable'>
                    <div className="doc-profile">

                    <div className="top-icon">
                    <span class="material-icons">ios_share</span>
                    <span class="material-icons">favorite_border</span>
                    </div>

                    <div className="left-container-doc">
                        <img
                            src={doc}
                            alt=''
                            className='doc-img'
                        />
                        <p> 120 ratings <b> 3/5 </b></p>
                    </div>

                    <div className="right-container-doc">
                        <h4 className='head'> Dr Amola Kumari, M.D</h4>
                        <p  className='head'>Orthopaedic surgeon | 12 Yrs Exp.</p>
                        <p  className='head'> <b>Practice Area:</b> Ankle sprain, Foot pain</p>
                        <div className="icon"><span class="material-icons"> location_on </span> <p className='head'> Old Palasia, Indore | Paras Hospital</p></div>
                        <p  className='head'> ₹500 Consultation fee at clinic</p>
                    </div>
                </div>  
            </a>

            <a href = './#/profile' class='clickable'>
                    <div className="doc-profile">

                    <div className="top-icon">
                    <span class="material-icons">ios_share</span>
                    <span class="material-icons">favorite_border</span>
                    </div>

                    <div className="left-container-doc">
                        <img
                            src={doc}
                            alt=''
                            className='doc-img'
                        />
                        <p> 50 ratings <b> 4.7/5 </b></p>
                    </div>

                    <div className="right-container-doc">
                        <h4 className='head'> Dr Amola Kumari, M.D</h4>
                        <p  className='head'>Orthopaedic surgeon | 12 Yrs Exp.</p>
                        <p  className='head'> <b>Practice Area:</b> Ankle sprain, Foot pain</p>
                        <div className="icon"><span class="material-icons"> location_on </span> <p className='head'> Old Palasia, Indore | Paras Hospital</p></div>
                       <p  className='head'> ₹500 Consultation fee at clinic</p>
                    </div>
                </div>  
            </a>
            
            <a href = './#/profile' class='clickable'>
                    <div className="doc-profile">

                    <div className="top-icon">
                    <span class="material-icons">ios_share</span>
                    <span class="material-icons">favorite_border</span>
                    </div>

                    <div className="left-container-doc">
                        <img
                            src={doc}
                            alt=''
                            className='doc-img'
                        />
                    <p> 50 ratings <b> 4.7/5 </b></p>

                    </div>

                    <div className="right-container-doc">
                        <h4 className='head'> Dr Amola Kumari, M.D</h4>
                        <p  className='head'>Orthopaedic surgeon | 12 Yrs Exp.</p>
                        <p  className='head'> <b>Practice Area:</b> Ankle sprain, Foot pain</p>
                        <div className="icon"><span class="material-icons"> location_on </span> <p className='head'> Old Palasia, Indore | Paras Hospital</p></div>
                        <p  className='head'> ₹500 Consultation fee at clinic</p>
                    </div>
                </div>  
            </a>
            <a href = './#/profile' class='clickable'>
                    <div className="doc-profile">

                    <div className="top-icon">
                    <span class="material-icons">ios_share</span>
                    <span class="material-icons">favorite_border</span>
                    </div>

                    <div className="left-container-doc">
                        <img
                            src={doc}
                            alt=''
                            className='doc-img'
                        />
                    <p> 50 ratings <b> 4.7/5 </b></p>

                    </div>

                    <div className="right-container-doc">
                        <h4 className='head'> Dr Amola Kumari, M.D</h4>
                        <p  className='head'>Orthopaedic surgeon | 12 Yrs Exp.</p>
                        <p  className='head'> <b>Practice Area:</b> Ankle sprain, Foot pain</p>
                        <div className="icon"><span class="material-icons"> location_on </span> <p className='head'> Old Palasia, Indore | Paras Hospital</p></div>
                        <p  className='head'> ₹500 Consultation fee at clinic</p>
                    </div>
                </div>  
            </a>
        </div>    

        </div>
    );
};

export default Doctors;
